module.exports = __webpack_public_path__ + "img/screen-listings.04e0599e.png";